import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "e482b0e6-1038-4e28-8e06-5a384b3936ae",
  publicId: "18",
  name: "Boundary conditions and degrees of freedom",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
